export type Features = {
    sandraVoice: boolean;
    showBillPaymentOption: boolean,
};

export type FeatureMapping = {
    [key: string]: Features;
};

const featureMapping: FeatureMapping = {
    'ovum': {
        sandraVoice: false,
        showBillPaymentOption: false,
    },
    'abchospital': {
        sandraVoice: true,
        showBillPaymentOption: true,
    },
    'localhost': {
        sandraVoice: true,
        showBillPaymentOption: true,
    },
    'default': {
        sandraVoice: false,
        showBillPaymentOption: true,
    },
  };
  
  export const getFeaturesForCustomer = () => {
    const domain = window.location.hostname;
  
    for (const key in featureMapping) {
      if (domain.includes(key)) {
        return featureMapping[key];
      }
    }
  
    return featureMapping['default'];
  };
  